import { motion } from "framer-motion";
import { Leaf } from "lucide-react";

const VEGAN_IMG =
    "https://static.prod-images.emergentagent.com/jobs/c2b7593f-ae8f-4892-a9ba-b424e7885b58/images/bb2057e7db338c750b2b93cb1afe76d4f202726fe38b41fa33fe63ac126a855a.png";

const POINTS = [
    {
        h: "Plant-Based, Island-Built",
        b: "Curry Chickpea Stew, Trini Jerk, BBQ Chickless, and Black Eyed Peas Savory Stew. Bold, satisfying, and fully plant-based.",
    },
    {
        h: "Fusion Without Compromise",
        b: "We blend traditional Jamaican technique with modern fine-dining presentation.",
    },
    {
        h: "Honest, Fresh, Local",
        b: "Sourced from Hudson Valley farms where possible. No shortcuts, no fillers.",
    },
];

export default function VeganFusion() {
    return (
        <section
            id="vegan"
            data-testid="vegan-fusion-section"
            className="relative empire-section bg-charcoal overflow-hidden"
            aria-label="Vegan & Fusion"
        >
            {/* Background image */}
            <div className="absolute inset-0 z-0">
                <img
                    src={VEGAN_IMG}
                    alt="Vegan Caribbean plate at Empire Jamaica Fusion"
                    className="absolute inset-0 h-full w-full object-cover opacity-30"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-charcoal via-charcoal/85 to-charcoal/55" />
                <div className="absolute inset-0 bg-gradient-to-b from-charcoal/40 to-charcoal/95" />
            </div>

            <div className="relative z-10 empire-container">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        className="lg:col-span-7"
                    >
                        <div className="inline-flex items-center gap-2 empire-eyebrow">
                            <Leaf size={14} className="text-gold" />
                            Vegan · Fusion · Caribbean
                        </div>
                        <h2
                            data-testid="vegan-heading"
                            className="mt-6 empire-subhead text-cream max-w-3xl"
                        >
                            Real Caribbean cuisine,<br />
                            <span className="italic text-gold">fully plant-based when you want it.</span>
                        </h2>
                        <p className="empire-body mt-6 max-w-2xl">
                            One of the few kitchens in the Hudson Valley cooking
                            vegan Caribbean food the proper way. Slow, deeply spiced,
                            and plated like everything else on our table. No
                            after-thought salads. No bland tofu.
                        </p>

                        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-px bg-cream/10 max-w-3xl">
                            {POINTS.map((p, i) => (
                                <div
                                    key={i}
                                    className="bg-charcoal-800/80 backdrop-blur-sm p-6"
                                    data-testid={`vegan-point-${i}`}
                                >
                                    <div className="font-serif text-cream text-lg leading-tight">
                                        {p.h}
                                    </div>
                                    <p className="mt-3 text-cream/65 text-[13px] font-light leading-relaxed">
                                        {p.b}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
